module.exports = __webpack_public_path__ + "img/OnlineGg.b85b4af6.png";